import { render, staticRenderFns } from "./OrderReturnSetComponentList.vue?vue&type=template&id=204be6e4&"
import script from "./OrderReturnSetComponentList.vue?vue&type=script&lang=js&"
export * from "./OrderReturnSetComponentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bensz/src/FrontendStudios/plentyDevTool/HuGVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204be6e4')) {
      api.createRecord('204be6e4', component.options)
    } else {
      api.reload('204be6e4', component.options)
    }
    module.hot.accept("./OrderReturnSetComponentList.vue?vue&type=template&id=204be6e4&", function () {
      api.rerender('204be6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/orderReturn/OrderReturnSetComponentList.vue"
export default component.exports